import React from 'react'

function TransactionUnlisted() {
  return (
    <div><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 13.3333H16.25C17.4006 13.3333 18.3333 12.4006 18.3333 11.25V5.41668C18.3333 4.26608 17.4006 3.33334 16.25 3.33334H7.08333C5.93274 3.33334 5 4.26608 5 5.41668V6.66668" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <rect x="1.66797" y="6.66666" width="13.3333" height="10" rx="2.5" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <ellipse cx="8.33464" cy="11.6667" rx="1.66667" ry="1.66667" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.5029 9.16249L12.4987 9.16665L12.4945 9.16249L12.4987 9.15832L12.5029 9.16249" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.17083 14.1625L4.16667 14.1667L4.1625 14.1625L4.16667 14.1583L4.17083 14.1625" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    </div>
  )
}

export default TransactionUnlisted